<template>
  <div class="flex flex-col gap-y-8 md:gap-y-12 px-5 md:px-0">
    <section class="px-0">
      <picture>
        <SourceGroup
          :srcset="`${content?.bannerMobile}`"
          height="384"
          width="767"
          :formats="['avif', 'webp', 'jpeg']"
          fit="cover"
          media="(max-width: 768px)"
          loading="eager"
        />
        <SourceGroup
          :srcset="`${content?.bannerDesktop}`"
          height="455"
          width="1366"
          :formats="['avif', 'webp', 'jpeg']"
          :media="'(min-width: 767px)'"
          fit="cover"
          loading="eager"
          sizes="100vw lg:1366"
        />
        <AppImage
          :src="content?.bannerResponsive ?? ''"
          :alt="content?.title ?? ''"
          class="mask object-cover lg:h-full w-screen"
          height="455"
          width="1366"
          loading="eager"
        />
      </picture>
    </section>
    <section
      v-for="section in content?.sections ?? []"
      :key="section?.id ?? ''"
      class="mt-8 flex flex-col items-start 2xl:flex-row justify-between gap-y-12 gap-x-8 lg:items-center px-0 md:px-8"
    >
      <picture>
        <SourceGroup
          :srcset="`${section?.imageMobile ?? ''}`"
          height="683"
          width="1366"
          :formats="['avif', 'webp', 'jpeg']"
          fit="cover"
          media="(min-width: 768px)"
          loading="lazy"
        />
        <SourceGroup
          :srcset="`${section?.imageDesktop ?? ''}`"
          height="455"
          width="1366"
          :formats="['avif', 'webp', 'jpeg']"
          :media="'(max-width: 767px)'"
          fit="cover"
          loading="lazy"
        />
        <AppImage
          :src="section?.imageResponsive ?? ''"
          :alt="section?.title ?? ''"
          class="mask object-cover h-full w-full rounded-2xs"
          height="455"
          width="1366"
          loading="lazy"
        />
      </picture>
      <div class="basis-2/4">
        <MainTitle el="h2" class="md:text-left">
          <template #before>
            <span class="md:text-2.6xl text-1.6xl normal-case">
              {{ section?.title ?? '' }}
            </span>
          </template>
        </MainTitle>
        <p class="px-5 md:px-0 mt-5 text-base text-primary-A900">
          {{ section?.description ?? '' }}
        </p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { params } = useRoute();
const { formatPageTitle } = useSeoFormatting();
const { fetchPages } = useGetSmartHomesPageContent();
const content = await fetchPages(params.slug?.toString() || '');

const page = content ?? null;

useAppSeoMeta({
  title: formatPageTitle(page?.title ?? ''),
  description: page?.description ?? '',
  image: page?.bannerResponsive ?? '',
});
</script>

<style scoped lang="postcss"></style>
